document.addEventListener("DOMContentLoaded", function () {


  const bragboard_card_links = document.querySelector('.bragboard-cards')


  bragboard_card_links.addEventListener('click', (e)=>{
    e.preventDefault();
    
    if(e.target.tagName === 'A' && e.target.className === "readmore-link"){
      
      let target_id = e.target.dataset.target;
      let target_content = document.querySelector(`span[data-profile=id-${target_id.toString()}]`);
      let card = document.getElementById(`profile-${target_id}`);
      
      // Open the rest of the content in card
      target_content.classList.toggle('open');

      // Remove the hash from the URL using HTML5 history API
      history.replaceState('', document.title, window.location.pathname + window.location.search);

      // Update the text of the link
      let target_status = e.target.dataset.status;

      if(target_status === "closed"){
        e.target.dataset.status = "open";
        e.target.innerHTML = "Read less";
      }else {
        e.target.dataset.status = "closed"
        e.target.innerHTML = "Read more";
      }


      if(card.dataset.collapsed === "true"){
        card.dataset.collapsed = "false"
      }else {
        card.dataset.collapsed = "true"
      }

    }// if readmore clicked

  })

  const dots = document.querySelector('.pagination .dots');
  const current_page = document.querySelector('.pagination .current .page-number');
  dots.parentNode.classList.add('dots-container')
  current_page.parentNode.classList.add('current-page-number')

}); // on doc read